module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "mobile-menu md:hidden"
  }, [_c('div', {
    staticClass: "mobile-menu-bar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.menuMobile
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'bars',
      "classname": 'w-8 h-8 text-white transform -rotate-90'
    }
  })], 1)]), _vm._v(" "), (!_vm.openmenu) ? _c('ul', {
    staticClass: "border-t border-theme-29 py-5 d-block"
  }, [_c('app-side-bar', {
    attrs: {
      "classname": 'menu'
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('nav', {
    staticClass: "side-nav"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "side-nav__devider my-6"
  }), _vm._v(" "), _c('app-side-bar', {
    attrs: {
      "classname": 'side-menu'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('app-top'), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-8"
  }, [_c('div', {
    staticClass: "col-span-12 lg:col-span-3 xxl:col-span-2"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("Trafico")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box p-5 mt-6"
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/tasks'
      ),
    },
    attrs: {
      "to": "/admin/traffic/tasks"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'file-plus',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Tareas\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/emails'
      ),
    },
    attrs: {
      "to": "/admin/traffic/emails"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'code',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Cortes\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/campaigns'
      ),
    },
    attrs: {
      "to": "/admin/traffic/campaigns"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'file',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Campañas\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/hours'
      ),
    },
    attrs: {
      "to": "/admin/traffic/hours"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'clock',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Horas Soporte\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/projects'
      ),
    },
    attrs: {
      "to": "/admin/traffic/projects"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'file',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Proyectos\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/accounts'
      ),
    },
    attrs: {
      "to": "/admin/traffic/accounts"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'folder',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Cuentas\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/profiles'
      ),
    },
    attrs: {
      "to": "/admin/traffic/profiles"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'target',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Perfiles\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/teams'
      ),
    },
    attrs: {
      "to": "/admin/traffic/teams"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'users',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Equipos\n                ")], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-9 xxl:col-span-10"
  }, [_c('router-view')], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "flex mr-auto",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "alt": "My Inxait",
      "src": "/static/images/logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "intro-x flex items-center pl-5 pt-4",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "w-32 xl:block",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f02d9e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminTraffic.vue
// module id = 455
// module chunks = 1